import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';
import { LangContext } from 'browser/contexts/LangContext';
import { ReactComponent as MoonSVG } from 'browser/assets/icons/moon.svg';
import { ReactComponent as SunSVG } from 'browser/assets/icons/sun.svg';

const Dot = styled.figure`
  position: absolute;
  top: 50%;
  left: 0;
  transform: translate(5px, -50%);
  width: 32px;
  height: 32px;
  background: #fff;
  border-radius: 50%;
  z-index: 1;
  transition: 0.3s;
  box-shadow: 0 1px 10px 2px rgba(0, 0, 0, 0.1);
`;

const NightSpan = styled.span`
  position: absolute;
  top: 50%;
  left: 10px;
  transform: translateY(-50%);
  font-size: 1.1rem;
  text-transform: uppercase;
  color: transparent;
  font-weight: 900;
  transition: 0.3s;
`;

const DaySpan = styled(NightSpan)`
  left: auto;
  right: 12px;
  text-align: right;
  color: #000;
`;

const DotInner = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
`;

const DotIcon = styled.div`
  position: absolute;
  top: 6px;
  left: 6px;
  transition: 0.3s;
  opacity: 0;
  visibility: hidden;
  svg {
    width: 20px;
    height: 20px;
  }
  ${({ visible }) =>
    visible &&
    css`
      opacity: 1;
      visibility: visible;
    `}
`;

const Wrapper = styled.div`
  position: relative;
  cursor: pointer;
  width: 90px;
  height: 40px;
  padding: 0;
  margin: 0 10px;
  background: #eeeeee;
  border-radius: 25px;
  transition: 0.3s;
  ${({ toggled }) =>
    toggled &&
    css`
      background: #000;
      & > ${Dot} {
        transform: translate(53px, -50%);
      }
      & > ${NightSpan} {
        color: #fff;
      }
      & > ${DaySpan} {
        color: transparent;
      }
    `}
`;

const DayNightSwitch = ({ toggle, isNight }) => {
  const { translate } = useContext(LangContext);
  return (
    <Wrapper id="nightmode-switch" onClick={toggle} toggled={isNight}>
      <DaySpan>{translate('day')}</DaySpan>
      <Dot>
        <DotInner>
          <DotIcon visible={!isNight}>
            <SunSVG />
          </DotIcon>
          <DotIcon visible={isNight}>
            <MoonSVG />
          </DotIcon>
        </DotInner>
      </Dot>
      <NightSpan>{translate('night')}</NightSpan>
    </Wrapper>
  );
};

DayNightSwitch.propTypes = {
  toggle: PropTypes.func.isRequired,
  isNight: PropTypes.bool.isRequired,
};

export default DayNightSwitch;
